import React from "react";
import {
  ToggleContainer,
  ToggleLabel,
  ToggleTitle,
  ToggleHint,
  ToggleSwitch,
  ToggleThumb,
} from "../styles";

const Toggle = ({ label, checked, onChange, hint }) => {
  return (
    <ToggleContainer>
      <ToggleLabel>
        <ToggleTitle>{label}</ToggleTitle>
        {hint && <ToggleHint>{hint}</ToggleHint>}
      </ToggleLabel>
      <ToggleSwitch
        onClick={() => onChange(!checked)}
        checked={checked}
        aria-label={label}
      >
        <ToggleThumb checked={checked} />
      </ToggleSwitch>
    </ToggleContainer>
  );
};

export default Toggle;
